import {
  GetMeetingVideoShareLinkRequest,
  GetMeetingVideoShareLinkResponse,
} from '@eigtech/meetings-types'
import { contextualGet, queryOptions, useQuery } from '@eigtech/ui-shared-api'
import { meetingsBasePath, meetingsQueryKeys } from './constants'

const getMeetingVideoShareLink = ({ entityId, meetingId }: GetMeetingVideoShareLinkRequest) =>
  contextualGet<GetMeetingVideoShareLinkResponse>(
    `${meetingsBasePath}/meeting/video-share/${entityId}/${meetingId}`
  )

const getMeetingVideoShareLinkQueryOptions = (request: GetMeetingVideoShareLinkRequest) =>
  queryOptions({
    queryKey: meetingsQueryKeys.shareUrl(request),
    queryFn: () => getMeetingVideoShareLink(request),
  })

export const useGetMeetingVideoShareLink = (
  request: GetMeetingVideoShareLinkRequest,
  { enabled }: { enabled: boolean } = { enabled: true }
) =>
  useQuery({
    ...getMeetingVideoShareLinkQueryOptions(request),
    enabled,
    refetchOnWindowFocus: enabled,
  })
